import cx from 'classnames'

export const DriveLogo = ({ alt = '', className, src, ...props }) => (
  <span className={cx('ds-drive-logo tw:inline-flex tw:h-7 tw:w-7 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full', className)} {...props}>
    <img alt={alt} className="tw:max-h-5 tw:max-w-5 tw:object-contain" src={src} />
  </span>
)
